import { render, staticRenderFns } from "./reference_material_writing_prompt.vue?vue&type=template&id=49c67af6&"
import script from "./reference_material_writing_prompt.vue?vue&type=script&lang=js&"
export * from "./reference_material_writing_prompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports